import { Link, Typography } from "@carrotfertility/carotene-core"
import { CircleImage } from "../../../views/atoms/images/CircleImage"
import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { RequirementCard } from "./requirement-card"

export const PartnerRequirementsCard = (): JSX.Element => {
  const intl = useIntl()
  return (
    <RequirementCard
      icon={<CircleImage iconName="icn-documents" backgroundColor={"black-10"} />}
      title={<FormattedMessage defaultMessage="Partner requirements" />}
      body={[
        <Typography key="partner-requirements" variant="body2">
          <FormattedMessage
            defaultMessage="Your partner must be enrolled in your employer's medical plan to use funds for eligible services. <link>Visit your benefit guide</link> for more information."
            values={{
              link: (linkContent) => (
                <Link
                  fontSize="inherit"
                  target="_blank"
                  href={"/your-benefit-guide"}
                  color="inherit"
                  aria-label={intl.formatMessage({ defaultMessage: "Visit your benefit guide" })}
                >
                  {linkContent}
                </Link>
              )
            }}
          />
        </Typography>
      ]}
    />
  )
}
